import React, {FC} from "react";
import {Card} from "react-bootstrap";
import {Field} from "formik";
import {FormikRowInput, FormikRowCheckbox, FormikRowSelect} from "@components/panel/formik";
import {RefRewardType} from "@interfaces/consumer/refs";

export interface RefRewardFormValues {
    name: string;
    order: number;
    isActive: boolean;
    type: RefRewardType;
    balance?: number;
    itemId?: string;
    count?: number;
    percent?: number;
    minSum?: number;
    maxSum?: number;
}

interface RefRewardBaseInfoBlockProps {
    editForm?: boolean;
}

const RefRewardBaseInfoBlock: FC<RefRewardBaseInfoBlockProps> = ({editForm}) => {
    return (
        <Card className="mb-3">
            <Card.Header as="h6" className="bg-body-tertiary">Основное</Card.Header>
            <Card.Body>
                <Field
                    label="Название"
                    name="name"
                    component={FormikRowInput}
                />

                <Field
                    label="Тип"
                    name="type"
                    component={FormikRowSelect}
                    disabled={editForm}
                >
                    <option value={RefRewardType.Balance}>Баланс</option>
                    <option value={RefRewardType.Item}>Предмет</option>
                    <option value={RefRewardType.Percent}>Процент доната</option>
                </Field>

                {editForm && (
                    <>
                        <Field
                            label="Активно"
                            name="isActive"
                            type="switch"
                            id="reward-active"
                            component={FormikRowCheckbox}
                        />

                        <Field
                            label="Порядковый номер"
                            name="order"
                            type="number"
                            component={FormikRowInput}
                        />
                    </>
                )}
            </Card.Body>
        </Card>
    );
};

export default RefRewardBaseInfoBlock;
